import { Paper, Box, Stack, Typography, Divider } from '@mui/material';

/**
 * A titled surface — the default container for a block of related content.
 * Keeps heading weight, padding and divider placement consistent instead of
 * every page inventing its own Paper + Typography combination.
 */
const SectionCard = ({ title, subtitle, action, children, dense = false, noPadding = false, sx }) => (
  <Paper sx={{ overflow: 'hidden', ...sx }}>
    {(title || action) && (
      <>
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
          spacing={2}
          sx={{ px: dense ? 2 : 2.5, py: dense ? 1.5 : 2 }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title && <Typography variant="h4">{title}</Typography>}
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Stack>
        <Divider />
      </>
    )}
    <Box sx={noPadding ? undefined : { p: dense ? 2 : 2.5 }}>{children}</Box>
  </Paper>
);

export default SectionCard;
